/**
 * Format papaparse response.
 *
 * @param {object} results - papaparse results
 * @returns {{data: Array, errors: Array}}
 */
export default (results) => {
    // prepare csv data
    const data = [];
    const errors = [];

    // merge rows to main array [[]] -> []
    for (let i = 0; i < results.data.length; i += 1) {
        data.push(results.data[i][0]);
    }

    // prepare errors text
    for (let n = 0; n < results.errors.length; n += 1) {
        const item = results.errors[n];
        errors.push(item.row ? `${item.message} at row ${item.row}` : item.message);
    }

    return {
        data,
        errors,
    };
};
